var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('i',{staticClass:"icon-location-pin"})]),_vm._v(" "),_c('template',{slot:"dropdown"},[_c('div',[_c('h6',{staticClass:"text-capitalize text-center"},[_vm._v("your dropdown")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("one")]),_vm._v(" "),_c('li',[_vm._v("two")]),_vm._v(" "),_c('li',[_vm._v("three")])])])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/containers/DefaultHeaderDropdown.vue?vue&type=template&id=541375da&
// module id = null
// module chunks = 